module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEDSURBVHgB7djbDYJAEIXhg7EAS6AFK9IOtBO1IkuwBOiAEsZjhMQbwu4CO5PMl2x4MWFHfxEBnHPOuYxE5MDVcFVcO1jBzW64TvKugQXcaNm+41+g3UsyYmqAnmRsDPAvGfUDDCWjdoCxyagcICQZdQNIYDJqBpDIZFIHWGMCPG/Jw5WrxMJWSPRIhocbMmw+yVTJZEkoZzKfghPSlkzMd6CAIlGbmTOhgkJeH3UV4jlqHrZcF1jHT+MoCb+8qVehSXqeMqlFEvpx0hqeVFxCsxDLt9Mded5qnCUQtJHApKCRWP5T3xmbFLQbSgoWiOVHi52epCpY0yZVtVnt4ZxzzgW4Ay3XJ+kRrUF3AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/about us_process_icon_left.png
// module id = hk0u
// module chunks = 0